export default class SidebarController {
  /* @ngInject */
  constructor(SidebarService, RouterService, MenuService, MediaQueryService, ProductService, MENU_CONSTANT) {
    this.sidebarService = SidebarService;
    this.menuService = MenuService;
    this.routerService = RouterService;
    this.mediaQueryService = MediaQueryService;
    this.productService = ProductService;
    this.MENU_CONSTANT = MENU_CONSTANT;
  }

  $onInit() {
    const {KEY} = this.MENU_CONSTANT;
    this.menu = [
      this.menuService.createGroup({key: KEY.HOME, slug: 'HOME', state: 'home'}),
      this.menuService.createGroup({key: KEY.WOMAN, label: 'Woman', matchOnUrl: '/woman/', matchOnSearch: 'genderId=W'}),
      this.menuService.createGroup({key: KEY.MAN, label: 'Man', matchOnUrl: '/man/', matchOnSearch: 'genderId=M'}),
      this.menuService.createGroup({key: KEY.KIDS, label: 'Baby', matchOnUrl: '/baby/', matchOnSearch: 'genderId=B'}),
      this.menuService.createGroup({key: KEY.UNISEX, label: 'Unisex', matchOnUrl: '/unisex/', matchOnSearch: 'genderId=X'}),
      this.menuService.createGroup({key: KEY.COMMUNICATION_TOOLS, slug: 'COMMUNICATION_TOOLS', matchOnUrl: '/communication-tool'}),
      // this.menuService.createGroup({key: KEY.EXTRA, label: 'Extra', matchOnUrl: 'extra'}),
    ];
  }

  $postLink() {
    this.menuService.get().then((data) => {
      this.onMenuSuccess(data);
    });
  }

  onMenuSuccess(data) {
    this.menu = this.updateMenu(data, this.menu);
  }

  findGroupByKey(key) {
    return group => group.key === key;
  }

  updateGroup(menu, key, optionsToUpdate) {
    const _clone = [...menu];
    _clone.forEach((group) => {
      if (group.key === key) {
        Object.keys(optionsToUpdate).forEach(k => group[k] = optionsToUpdate[k]);
      }
    });
    return _clone;
  }

  updateMenu(data, menu) {
    const {KEY} = this.MENU_CONSTANT;
    const newWoman = data.find(group => group.key === KEY.WOMAN) || [];
    const newMan = data.find(group => group.key === KEY.MAN) || [];
    const newKids = data.find(group => group.key === KEY.KIDS) || [];
    const newUnisex = data.find(group => group.key === KEY.UNISEX) || [];
    const newCommunicationTools = data.find(group => group.key === KEY.COMMUNICATION_TOOLS) || [];
    let _menu = [...menu];
    _menu = this.updateGroup(_menu, KEY.WOMAN, {children: newWoman.children});
    _menu = this.updateGroup(_menu, KEY.MAN, {children: newMan.children});
    _menu = this.updateGroup(_menu, KEY.KIDS, {children: newKids.children});
    _menu = this.updateGroup(_menu, KEY.UNISEX, {children: newUnisex.children});
    _menu = this.updateGroup(_menu, KEY.COMMUNICATION_TOOLS, {children: newCommunicationTools.children});
    return _menu;
  }

  toggleLinks(group, {isMouseOver} = {}) {
    const isDesktopMouseOver = this.mediaQueryService.is('desktop') && isMouseOver;
    if ((isDesktopMouseOver || !isMouseOver) && !group.state) {
      this.toggleGroup(group);
    }
    if (group.state && !isMouseOver) {
      this.goTo(group);
    }
  }

  toggleGroup(group = {}) {
    this.menu.forEach((g) => {
      if (g.key === group.key) {
        group.isOpen = !group.isOpen;
      } else {
        g.isOpen = false;
      }
    });
  }

  goTo(elem) {
    this.toggleGroup();
    this.sidebarService.close();
    this.productService.resetStore();
    if (elem.state === 'home') {
      this.sidebarService.goHome();
      return;
    }

    const marketId = this.routerService.location.search().marketId || elem.params.marketId;
    const regionId = this.routerService.location.search().regionId || elem.params.regionId;
    const hasImages = this.routerService.location.search().hasImages;
    const availability = this.routerService.location.search().availability;
    const paramsWithGeography = {...elem.params, marketId, regionId, hasImages, availability };
    // reload true in modo da permettere il caricamento dei nuovi params anche se siamo sulla stessa view
    // esempio: sono nella lista dei prodotti con genderId: M, clicco per avere genderId: W -> se non ho
    // reload: true, non avverrà nessun cambiamento
    this.routerService.state.go(elem.state, paramsWithGeography, {reload: true});
  }

  isActiveInUrl(group) {
    return (this.mediaQueryService.is('desktop') && window.location.href.indexOf(group.matchOnUrl) >= 0)
      || (this.mediaQueryService.is('desktop') && window.location.href.indexOf(group.matchOnSearch) >= 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.controller.js